import { courseStatus } from "../../constants/course";

export const getStatusTitle = (id: string) => {
  return courseStatus.find((status) => status.id === id)?.title;
};